export default __webpack_public_path__ + "static/media/discoveryChannel.b1a68e04.png";